export type SalesMonthlyItem = {
  location_name: string
  location_id?: number | null
  budget_id?: number | null
  budget: string | null
  average: string | null
  january: string | null
  february: string | null
  march: string | null
  april: string | null
  may: string | null
  june: string | null
  july: string | null
  august: string | null
  september: string | null
  october: string | null
  november: string | null
  december: string | null
  formula?: string
  code_budget?: string
}

export type SalesMonthlyGroup = {
  category: string
  code_budget: string
  items: SalesMonthlyItem[]
}

export const MONTH_KEYS = [
  "january", "february", "march", "april",
  "may", "june", "july", "august",
  "september", "october", "november", "december"
] as const

export type MonthKey = typeof MONTH_KEYS[number]
